<template>
  <transition name="bounce">
    <div class="bb-toolbar" v-if="hover === row.id">
      <i class="icon-edit bb-toolbar__icon" @click.stop="setEditItem"/>
      <i class="icon-trash-1 bb-toolbar__icon bb-toolbar__icon_red"
         @click.stop="setOpenDelete($event, true)">
        <transition name="bb-bounce">
          <div class="bb-toolbar-confirm"
               @click.stop
               v-if="deleteOpen"
               :style="popupPosition"
               v-click-outside="closeConfirmDelete"
               @mouseleave="closeConfirmDelete"
          >
            <div>Are you sure?</div>
            <div class="bb-toolbar-confirm-controls">
              <button class="bb-button bb-toolbar-confirm-controls__button" @click.stop="deleteItem">yes</button>
              <button class="bb-button bb-toolbar-confirm-controls__button" @click.stop="closeConfirmDelete">no
              </button>
            </div>
          </div>
        </transition>
      </i>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BBToolbarTable',
  props: ['row', 'column', 'index', 'hover', 'right'],
  data () {
    return {
      deleteOpen: false,
      popupPosition: {}
    }
  },
  methods: {
    updateItem ({row, column, value}) {
      this.$emit('update', {row, column, value})
    },
    closeConfirmDelete () {
      this.popupPosition = {}
      this.deleteOpen = false
    },
    deleteItem () {
      const currentElem = {row: this.row, column: this.column, index: this.index}
      this.$emit('delete', currentElem)
    },
    setEditItem () {
      const currentElem = {row: this.row, column: this.column, index: this.index}
      this.$emit('edit', currentElem)
      this.closeConfirmDelete()
    },
    setOpenDelete (e, val) {
      this.deleteOpen = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.popupPosition = {
          position: 'fixed',
          top: position.top + 'px',
          right: 'auto',
          left: this.right ? position.left + 30 + 'px' : position.left - 127 + 'px'
        }
      } else {
        this.popupPosition = {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-toolbar {
  display: grid;
  grid-template-columns: repeat(auto-fill, 21px);
  grid-gap: 10px;

  &__icon {
    position: relative;
    width: 21px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
    color: $color-wild-sand;
    cursor: pointer;

    &:hover {
      &:after {
        opacity: 0.8;
      }
    }

    &:before {
      z-index: 2;
    }

    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 1px;
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      border-radius: 50%;
      background-color: $color-accent;
      z-index: 1;
      transition: 0.3s;
    }

    &_red {
      &:after {
        background-color: $color-pomegranate;
      }
    }
  }

  &-confirm {
    @include global-font;
    position: absolute;
    top: 0;
    right: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 117px;
    background-color: $color-white;
    box-shadow: 0 0 15px rgba($color-black, 0.05);
    border-radius: 5px;
    padding: 14px;
    color: $color-black;
    font-size: 14px;
    line-height: 17px;
    z-index: 20;
    cursor: default;

    &_right {
      left: 30px;
      right: 0;
    }

    &-controls {
      display: grid;
      justify-content: space-between;
      align-items: center;
      grid-template-columns: 39px 39px;
      grid-gap: 10px;
      margin-top: 13px;

      &__button {
        text-transform: capitalize;
        font-weight: 400;
        font-size: 13px;
        height: auto;
        line-height: 16px;
        padding: 5px 8px;
        cursor: pointer;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/Toolbar/Toolbar.vue